enum ProductComplianceLabelTypeEnum {
	chileEnergyCompliance = 'ENERGY_LABEL_CL',
	chileSecLabel = 'SEC_LABEL_CL',
	usEnergy = 'ENERGY_LABEL_US',
	euEnergy = 'ENERGY_LABEL_EU',
	euUnifiedWaterLabel = 'WATER_LABEL_EU',
	repairabilityIndexDocument = 'REPAIR_DOC_FR',
	repairabilityIndexImage = 'REPAIR_INDEX_FR'
}

export default ProductComplianceLabelTypeEnum;
